var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 9",
    fill: "#00897D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00061 8.50602C7.92195 8.50608 7.84406 8.49058 7.77141 8.46043C7.69876 8.43028 7.63278 8.38607 7.57727 8.33034L0.363684 1.11783C0.263715 1.00322 0.210991 0.854931 0.216169 0.702939C0.221347 0.550948 0.284041 0.406591 0.391578 0.299055C0.499115 0.191518 0.643472 0.128823 0.795464 0.123645C0.947456 0.118467 1.09574 0.171193 1.21035 0.271162L8.00061 7.0577L14.7887 0.271162C14.9029 0.168632 15.052 0.113777 15.2054 0.117892C15.3588 0.122006 15.5048 0.184776 15.6133 0.293278C15.7218 0.40178 15.7846 0.547755 15.7887 0.701144C15.7928 0.854534 15.7379 1.00366 15.6354 1.11783L8.425 8.33034C8.36933 8.38615 8.30318 8.43041 8.23034 8.46056C8.15751 8.49071 8.07943 8.50616 8.00061 8.50602Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.9afde1e2956b00a069d4e546faf6c4fb.svg";
export { ForwardRef as ReactComponent };